import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import softwareDevelop from "../images/software-development.avif";
import { Helmet } from "react-helmet-async";

export default function Softwaredevelopmentservices() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  const expertiseAreas = [
    { icon: "fa-code", title: "Java, PHP, SQL & More", desc: "Our developers master multiple languages and frameworks to build versatile, high-performance solutions tailored to your exact requirements." },
    { icon: "fa-database", title: "Complex & Scalable Databases", desc: "We design robust, secure, and scalable database architectures that handle massive data efficiently and support real-time business decisions." },
    { icon: "fa-cogs", title: "C# & .NET Development", desc: "Building powerful, enterprise-grade applications with C# and .NET — reliable, maintainable, and ready for future growth." },
    { icon: "fa-shield-check", title: "Software Quality Assurance", desc: "Rigorous testing at every stage ensures bug-free, secure, and high-quality software that exceeds user expectations." },
    { icon: "fa-terminal", title: "Advanced SQL Mastery", desc: "Expert query writing, optimization, and analysis — delivering lightning-fast data operations and insightful reporting." },
    { icon: "fa-brain", title: "Intelligent Business Logic", desc: "We craft sophisticated business rules and automation logic that make your software smarter, faster, and more profitable." },
  ];

  return (
    <div>
      <Helmet>
        <title>Custom Software Development Services - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/software-development-services/" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Software Development Services
            </h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mt-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="row align-items-center g-5">
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1200">
            <div className="section-title text-start mb-4">
              <h2>Making Businesses Flourish</h2>
              <h3 style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                With Our <span>Custom Software Solutions</span>
              </h3>
            </div>
            <p style={{ textAlign: "justify", lineHeight: 1.8, fontSize: "1.05rem" }}>
              From idea to deployment — we deliver full-cycle custom software that solves real business problems, increases efficiency, reduces costs, and drives measurable growth.
            </p>
            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              Whether it's enterprise-grade applications, complex system integrations, modern web & mobile solutions, or mission-critical business tools — our experienced engineers build secure, scalable, and future-proof software tailored precisely to your needs.
            </p>
          </div>

          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
            <img
              src={softwareDevelop}
              alt="Custom Software Development"
              className="img-fluid "
              style={{ borderRadius: "16px" }}
            />
          </div>
        </div>
      </div>

      {/* How We Do It - Expertise Cards */}
      <div className="container my-1 py-1" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-2">
          <h3>How We Build World-Class Software</h3>
        </div>
        <div className="row g-4">
          {expertiseAreas.map((item, i) => (
            <div className="col-lg-4 col-md-6" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '16px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <i
                  className={`fa-solid ${item.icon} fa-4x mb-4`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <h5 className="mb-3 fw-bold">{item.title}</h5>
                <p className="mb-0 small" style={{ lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Closing / Vision Section */}
      <div
        className="container-fluid py-3"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}08 0%, #f8f9fa 100%)`,
        }}
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h3 className="mb-4" style={{ fontWeight: 700 }}>
                Driven by Client Success & Global Ambition
              </h3>
              <p className="lead mb-4" style={{ lineHeight: 1.8 }}>
                With deep expertise across e-Commerce, e-Learning, Finance, Manufacturing, Enterprise Systems and more — we create powerful, domain-specific software that gives businesses a real competitive edge.
              </p>
              <p style={{ fontSize: "1.1rem", maxWidth: "900px", margin: "0 auto 2rem" }}>
                As one of Pakistan's most trusted software houses, we deliver unmatched quality in custom development, system integration, QA, and long-term support. Our vision goes far beyond borders — we aim to become a globally recognized leader in innovative, reliable, and impactful software solutions.
              </p>

        <a
  href="/contact"
  className="primaryBtn px-4 py-2 mb-3"
  style={{ display: "inline-block" }}
>
  Start Your Project Today &rarr;
</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}